(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/get-payment-message/get-payment-confirm-message.js') >= 0) return;  svs.modules.push('/components/sport/get-payment-message/get-payment-confirm-message.js');

'use strict';

const {
  Currency
} = svs.utils.format;
const getCost = amount => {
  const nonBreakingAmountString = Currency(amount, false).split(' ').join('\xA0');
  return "".concat(nonBreakingAmountString, "\xA0kr");
};

function getPaymentConfirmMessage(_ref) {
  let {
    amount,
    productName,
    marketplaceGroup = null,
    compDesc = null,
    tipsetBombenAmount = null,
    isMultipleWagers = false
  } = _ref;
  if (!amount || !productName) {
    throw new Error('Missing required properties `amount` or `productName`');
  }
  const paymentConfirmDialogConfig = {
    price: amount,
    product: productName,
    messages: [],
    title: undefined
  };
  if (marketplaceGroup) {
    paymentConfirmDialogConfig.title = "Vill du betala ett spel p\xE5 ".concat(productName, " f\xF6r ").concat(getCost(amount), " \xE5t ").concat(marketplaceGroup, "?");
    paymentConfirmDialogConfig.messages.push('Kvarvarande pengar återbetalas till medlemmarna.');
  } else if (tipsetBombenAmount) {
    paymentConfirmDialogConfig.title = "Vill du betala ett spel p\xE5 ".concat(productName, " f\xF6r ").concat(getCost(amount), " och ett spel p\xE5 Bomben f\xF6r ").concat(getCost(tipsetBombenAmount), "?");
  } else if (compDesc) {
    paymentConfirmDialogConfig.title = "Vill du betala ett spel p\xE5 ".concat(productName, " f\xF6r ").concat(getCost(amount), "?");
    paymentConfirmDialogConfig.messages.push("Ditt spel kommer att delta i ".concat(compDesc, "."));
  }
  if (isMultipleWagers) {
    paymentConfirmDialogConfig.messages.push('Notera att maxgränsen för systemet är nått. Spelet kommer att delas upp och hittas under Mina Spel');
  }
  return paymentConfirmDialogConfig;
}
setGlobal('svs.components.sport.getPaymentConfirmMessage', getPaymentConfirmMessage);

 })(window);